<template>
  <section class="afp" aria-label="Files">
    <div class="afp-head">
      <div class="afp-titles">
        <b>Files</b>
        <span>Reports and sheets Connect made for you, kept {{ assistant.filesKeepDays }} days. Only you see them.</span>
      </div>
      <button type="button" class="afp-close" @click="$emit('close')">Close</button>
    </div>
    <ReasonConfirm
      v-if="asking"
      title="Delete this file?"
      :text="$trf('“{0}” is removed for good.', [asking.name])"
      confirmLabel="Delete"
      :askReason="false"
      danger
      @confirm="remove"
      @cancel="asking = null"
    />
    <p class="afp-empty" v-if="assistant.filesLoading && !assistant.files.length">Loading…</p>
    <p class="afp-empty" v-else-if="!assistant.files.length">Nothing yet. Ask Connect for one, for example “Make a PDF report of last week's sales by store”.</p>
    <div class="afp-list" v-else>
      <AssistantFileCard v-for="f in assistant.files" :key="f.id" :file="f" deletable @delete="asking = f" />
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import AssistantFileCard from "./AssistantFileCard.vue";

/** Files: everything Connect made for the signed-in person (2026-10-20), newest first, to download again or delete. */
export default {
  name: "AssistantFilesPanel",
  components: { AssistantFileCard },
  emits: ["close"],
  data() {
    return { asking: null };
  },
  computed: {
    ...mapState({ assistant: (s) => s.assistant }),
  },
  mounted() {
    this.$store.dispatch("assistantFiles");
  },
  methods: {
    async remove() {
      const f = this.asking;
      this.asking = null;
      if (f) await this.$store.dispatch("assistantFileDelete", f.id);
    },
  },
};
</script>

<style scoped>
.afp { box-sizing: border-box; flex: 0 1 auto; display: flex; flex-direction: column; gap: 10px; max-height: 60%; overflow-y: auto; margin: var(--s-2) 0; padding: 12px; border: 1px solid var(--border-primary); border-radius: 14px; background: var(--bg-secondary); }
.afp-head { display: flex; align-items: flex-start; gap: 10px; }
.afp-titles { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.afp-titles b { font-size: var(--t-body-sm); font-weight: 650; color: var(--text-primary); }
.afp-titles span { font-size: var(--t-caption); line-height: var(--t-caption-lh); color: var(--text-muted); }
.afp-close { flex: none; padding: 0; border: 0; background: transparent; font: inherit; font-size: var(--t-caption); font-weight: 600; color: var(--text-link); cursor: pointer; }
.afp-close:hover { text-decoration: underline; }
.afp-empty { margin: 0; font-size: var(--t-body-sm); line-height: 1.5; color: var(--text-muted); }
.afp-list { display: flex; flex-direction: column; gap: 8px; }
</style>
